import ButtonContainer from "@components/ButtonContainer";
import FormTextField from "@components/Shared/FormTextField";
import PasswordField from "@easydev/form/Password";
import IFormProps from "@interfaces/Shared/formProps";
import { ReactElement } from "react";
import { Field } from "react-final-form";

const CreateUserForm = ({ handleSubmit, form }: IFormProps): ReactElement => (
  <form className="form form--horizontal" onSubmit={handleSubmit}>
    <div className="form__form-group">
      <span className="form__form-group-label">{"Name"}</span>
      <div className="form__form-group-field">
        <Field
          name="name"
          component={FormTextField}
          type="text"
          placeholder="John"
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">{"Last name"}</span>
      <div className="form__form-group-field">
        <Field
          name="lastname"
          component={FormTextField}
          type="text"
          placeholder="Doe"
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">{"Username"}</span>
      <div className="form__form-group-field">
        <Field
          name="username"
          component={FormTextField}
          type="text"
          placeholder="jdoe"
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">{"Mail"}</span>
      <div className="form__form-group-field">
        <Field
          name="mail"
          component={FormTextField}
          type="email"
          placeholder="john.doe@nftstudios.io"
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Password</span>
      <div className="form__form-group-field">
        <Field
          name="password"
          component={PasswordField as any}
          placeholder={"Password"}
          keyIcon
          isAboveError
        />
      </div>
    </div>

    <div className="form__form-group">
      <span className="form__form-group-label">Confirm Password</span>
      <div className="form__form-group-field">
        <Field
          name="confirmpassword"
          component={PasswordField as any}
          placeholder={"Confirm Password"}
          keyIcon
          isAboveError
        />
      </div>
    </div>

    <ButtonContainer />
  </form>
);

export default CreateUserForm;
